import React from 'react';

const initiatives = [
  {
    title: 'Pad Drives',
    description: 'Providing essential hygiene products for girls and women in need. Join us in making a difference by supporting our pad drives and ensuring dignity for all.',
    image: '/assets/khisa1.jpg',
    tag: 'Health & Dignity',
  },
  {
    title: 'Mentorship for Change',
    description: 'Guiding youth and fostering skills for a brighter future. Our mentorship program connects young individuals with experienced mentors who inspire growth.',
    image: '/assets/khisa5.jpg',
    tag: 'Youth Development',
  },
  {
    title: 'Inspiring a Loving World',
    description: 'Promoting compassion and community care through various outreach programs. Help us build a more loving and caring community through acts of kindness.',
    image: '/assets/khisa3.jpg',
    tag: 'Community Outreach',
  },
  {
    title: 'Digital Literacy',
    description: 'Equipping individuals with crucial digital skills for the modern world. Our digital literacy program empowers communities to thrive in the digital era.',
    image: '/assets/khisa4.jpg',
    tag: 'Education & Skills',
  },
];

function Initiatives() {
  return (
    <div>
      {/* Page header */}
      <div className="bg-gray-900 text-white py-20 px-4 text-center">
        <span className="inline-block text-red-400 text-sm font-semibold uppercase tracking-widest mb-4">What We Do</span>
        <h1 className="text-4xl md:text-6xl font-black mb-4 leading-tight">Our Initiatives</h1>
        <p className="text-gray-400 text-lg max-w-xl mx-auto">
          Four focused programs designed to uplift communities and create lasting change.
        </p>
      </div>

      {/* Initiatives grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {initiatives.map((item, index) => (
              <div key={index}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
                {/* Image with overlay */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <span className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-red-600 text-xs font-semibold px-3 py-1 rounded-full">
                    {item.tag}
                  </span>
                </div>
                {/* Content */}
                <div className="p-7">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Initiatives;
